/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function (){
  $("#section-template--16505907445996__166417546129b10dc1 .Button, #section-template--16505907445996__16641662809b2e57c3 .Button, #section-template--16505907445996__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16505907445996__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16772824629484__16641662809b2e57c3 .Button, #section-template--16772824629484__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16772824629484__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16779947868396__16641662809b2e57c3 .Button, #section-template--16779947868396__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16779947868396__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

  
  
  $("#section-template--16529213489388__1664598339f24fab42 .Button, #section-template--16529213489388__1664539947f0d9dc4a .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16529213489388__16645405943a339b02').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16617840804076__616655a8-2f7d-4eaf-91af-62990491fac0 .Button, #shopify-section-template--16617840804076__efaa64c5-6393-45a8-8cd6-ac554a0933e4 .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16617840804076__63b89025-dfdd-4288-b1fd-e05eb178e82a').offset().top - 80
       }, 1000);               
  });

  $("#section-template--16623219638508__06856d80-de69-43ba-a936-de47a79c4acb .Button, #section-template--16623219638508__2b4d11a9-ec70-4eee-b8ae-7fd530983a11 .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16623219638508__8c42e1ff-1242-4853-979f-93188ff57462').offset().top - 80
       }, 1000);               
  });

  

  /*-------------- interior popup --------------*/
  $('#section-template--16396379160812__1661862977e9eb5476 .Button, #section-template--16396379160812__16618665072148d65a .Button').on('click', function(e){
    e.preventDefault();
    $('#interiorModal').show();
  });
  $('.interior_close').on('click', function(){
    $('#interiorModal').hide();
  });
  var interiorModal = document.getElementById("interiorModal");
  window.onclick = function(event) {
    if (event.target == interiorModal) {
      interiorModal.style.display = "none";
    }
  }
  $('.dimension-heading').on('click', function(){
    $(this).parent().find('.dimension-content').slideToggle();
    $(this).toggleClass('open');
  });
  $('.additional_details-heading').on('click', function(){
    $(this).parent().find('.additional_details-content').slideToggle();
    $(this).toggleClass('open');
  });
});


$(document).ready(function() {
    // Open popup on button click
    $('#member-pricing-btn').click(function() {
        $('#popupmem').fadeIn();
        $('body').addClass('no-scrolln');
    });
 
    // Close popup on close button click or outside click
    $('.closemem-btn, .popup-overlaymem').click(function() {
        $('#popupmem').fadeOut();
            $('body').removeClass('no-scrolln');
    });
 
    // Prevent closing the popup when clicking inside content
    $('.popupmem-content').click(function(event) {
        event.stopPropagation();
    });
});